import * as React from "react"

export const ChecklistItem = ({ children, className = "" }) => {
  return (
    <li className={`checklist__item ${className}`}>
      <p className="checklist__description">{children}</p>
    </li>
  )
}

export const Checklist = ({ children, className = "" }) => {
  return <ul className={`mt-6 ${className}`}>{children}</ul>
}
